// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QehHC366SOhESh32xT1a {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.HcWBEDTOYjbgX0Tio2N2 {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    margin: 0 auto;
}

.aKsdFpsDlwe79leIRRbR {
    padding: 24px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/EmailPreferences/EmailPreferences.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".page {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    margin: 0 auto;\n}\n\n.card {\n    padding: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `QehHC366SOhESh32xT1a`,
	"content": `HcWBEDTOYjbgX0Tio2N2`,
	"card": `aKsdFpsDlwe79leIRRbR`
};
export default ___CSS_LOADER_EXPORT___;
